export function popups() {
    $(window).on("load", function () {
        const mainWrap = $("body");
        const videoPopup = $('#popup-video');

        function closePopup() {
            videoPopup.find('.video-wrap').html('');
            $(".popup").removeClass("active");
            mainWrap.removeClass("popup-open");
        }

        $(document).on("click", ".popup-link", function (event) {
            event.preventDefault();

            let $this = $(this);
            let $url = $this.attr("href");
            let parseUrl = $url.split('#');
            let $target = '#' + parseUrl[1];

            if ($this.attr('data-member')) {
                let data = {
                    'action': 'member_info',
                    'post_id': $(this).attr("data-member")
                };

                $.ajax({
                    url: ajaxvars.ajaxurl,
                    data: data,
                    type: 'POST',
                    success: function (response) {
                        $($target).find('.popup-body').html(response);
                    },
                    complete: function () {
                        $($target).addClass("active").fadeIn(300);
                        mainWrap.addClass("popup-open");
                        if ($(".jcf-scrollable").length && $("body").hasClass("no-touch")) {
                            jcf.replaceAll();
                        }
                    }
                });
            }
            if ($this.hasClass('play-video')) {
                let video;
                const href = $this.attr("href");
                $target = '#popup-video';
                if (href !== '#') {
                    const src = href + '?enablejsapi=1&autoplay=0';
                    video = `<iframe src="${src}" allow="autoplay" allowfullscreen playsinline></iframe>`
                }
                videoPopup.find('.video-wrap').append(video);
                const videoIframe = videoPopup.find('iframe');

                setTimeout(() => {
                    if (videoIframe.length) {
                        videoIframe[0].contentWindow.postMessage('{"event":"command", "method":"play", "func":"' + 'playVideo' + '","args":""}', '*');
                    }
                }, 1700);
                $($target).addClass("active").fadeIn(300);
                mainWrap.addClass("popup-open");
            }

            if ($target === "#popup-consultation") {
                $($target).addClass("active").fadeIn(300);
                mainWrap.addClass("popup-open");
            }

        }).on("click", ".popup-close", function () {
            closePopup.call(this);
        });


        $(".popups").on("click", function (event) {
            if (!$(event.target).closest(".popup-holder").length && !$(event.target).parents('.jcf-select-drop').length) {
                closePopup.call(this);
            }
        });

        $('.popup-consultation select').each(function () {
            $(this).find('option:first').attr('disabled', 'disabled');
        });
    });
}




// WEBPACK FOOTER //
// ./assets/js/modules/popups.js